var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("UploadDocument", {
    attrs: {
      currentUserId: _vm.currentUserId,
      currentUser: _vm.currentUser,
      preventAutoUploading: "",
    },
    on: { fileUpdated: _vm.attachNewFile },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ addFile, removeFile, uploadFile }) {
          return [
            _c("ModalFullScreen", {
              attrs: { size: "lg", title: _vm.applicationTitle },
              on: {
                close: function ($event) {
                  return _vm.$emit("close")
                },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "form",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "flex flex-col" },
                          [
                            _vm._t("default"),
                            _c("div", { staticClass: "mb-4" }, [
                              !_vm.newFile
                                ? _c("div", { staticClass: "text-label" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex items-baseline mb-1",
                                      },
                                      [
                                        _c("UiButton", {
                                          staticClass: "mr-1",
                                          attrs: {
                                            buttonText: _vm.attachButtonText,
                                            variant: "linkButton",
                                            size: "no",
                                            buttonClasses: "no-underline",
                                          },
                                          on: { click: addFile },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "textSmall" },
                                          [_vm._v("Resume or Cover letter")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _c(
                                    "div",
                                    [
                                      _c(
                                        "CardBodyItem",
                                        {
                                          attrs: {
                                            label: "Attached document",
                                            labelClass: "w-auto mr-2",
                                          },
                                        },
                                        [
                                          _c("AttachedDocument", {
                                            attrs: { name: _vm.newFile.name },
                                            on: { remove: removeFile },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                            ]),
                          ],
                          2
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "actions",
                    fn: function () {
                      return [
                        _c("ModalSectionsDivider"),
                        _c(
                          "div",
                          { staticClass: "flex pt-5 ml-auto" },
                          [
                            _c("UiButton", {
                              staticClass: "mr-4",
                              attrs: {
                                size: "lg",
                                buttonText: "Cancel",
                                variant: "outline",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("close")
                                },
                              },
                            }),
                            _c("UiButton", {
                              attrs: {
                                buttonText: _vm.actionButtonText,
                                disabled: false,
                                size: "lg",
                                variant: "black",
                                processing: _vm.processing,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.update(uploadFile)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }